import { render, staticRenderFns } from "./ResetDialog.vue?vue&type=template&id=8b68dd08&scoped=true"
import script from "./ResetDialog.vue?vue&type=script&lang=js"
export * from "./ResetDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetDialog.vue?vue&type=style&index=0&id=8b68dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b68dd08",
  null
  
)

export default component.exports